var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9498 3.05086C11.2157 2.31008 10.3245 1.74368 9.34212 1.39348C8.35973 1.04328 7.31123 0.918221 6.27403 1.02754C3.0595 1.35162 0.414299 3.96179 0.0551826 7.17632C-0.426559 11.4244 2.85804 15.0068 7.00102 15.0068C8.32372 15.0068 9.61926 14.6315 10.7371 13.9245C11.855 13.2175 12.7494 12.2078 13.3162 11.0127C13.5965 10.4259 13.1761 9.75145 12.5279 9.75145C12.2038 9.75145 11.8973 9.92663 11.7571 10.2157C11.2486 11.3097 10.3788 12.1952 9.29404 12.7232C8.2093 13.2512 6.9758 13.3895 5.80105 13.1149C3.85656 12.6857 2.28871 11.1003 1.87704 9.15584C1.70399 8.38703 1.706 7.58916 1.88291 6.82123C2.05982 6.0533 2.4071 5.33497 2.89908 4.71937C3.39106 4.10377 4.01514 3.60664 4.72516 3.26477C5.43518 2.92289 6.21298 2.74502 7.00102 2.7443C8.45501 2.7443 9.75133 3.34866 10.6973 4.30339L9.3747 5.62599C8.82288 6.1778 9.20828 7.12377 9.98782 7.12377H13.1323C13.614 7.12377 14.0082 6.72961 14.0082 6.24787V3.10341C14.0082 2.32387 13.0622 1.92971 12.5104 2.48153L11.9498 3.05086Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.1c7685ddd04c14e37d026ed7db127e90.svg";
export { ForwardRef as ReactComponent };